import type { StreamStatus } from '@/domains/disclosure/enums';
import type { SSEStreamService } from '@patsnap-utils/sse';

export const GetContentOpt = Symbol('GetContentOpt');


import type { AIDisclosureParagraphEditType } from '@/domains/disclosure/enums';

export interface ApiGetContentRequest<OperateType> {
    task_id: string;
    operate_type: OperateType;
    text: string;
    content_type: string;
}

export type ApiContentResponse = {
    content: string;
    status: StreamStatus;
};

export interface GetContentOpt {
    getContentOpt(data: ApiGetContentRequest<AIDisclosureParagraphEditType>): SSEStreamService<ApiContentResponse>;
}
